define.alias("shared/components/shared/credentials/instagram-auth-status", "calendar/components/shared/credentials/instagram-auth-status");